import { useState } from 'react'
import { Button } from 'blaze-ui/Button'
import { Text } from 'blaze-ui/Text/Text'
import { LinkExternal } from 'blaze-ui/icons'
import Styles from '../MetaAdsAccountSetupModal.module.scss'
import { Search } from 'components/Templates/TemplatesModalV2/components/Search'
import { MetaAdsFacebookSelectProps } from './Types'
import { openWindowSafely } from 'hooks/useOpenWindowSafely'
import { FacebookAccountCard } from './FacebookAccountCard'

export const MetaAdsFacebookSelect = (props: MetaAdsFacebookSelectProps) => {
  const { selectedAccountId, onSelectAccount, facebookPages } = props

  const [search, setSearch] = useState('')
  const filteredFacebookPages = facebookPages.filter((page) => page.name.toLowerCase().includes(search.toLowerCase()))

  const handleLinkAdAccount = () => {
    openWindowSafely('https://business.facebook.com/')
  }

  return (
    <div className={Styles.setupContainer}>
      <div className={Styles.section}>
        <Text variant="secondary">
          Select the Facebook Page and Instagram Page you want to use to run your ads. Your profile name will be shown
          in the ads.
        </Text>
      </div>

      <div className={Styles.selectContentContainer}>
        <Search onChange={setSearch} query={search} placeholder="Search your pages..." useCompactUI />

        {filteredFacebookPages.map((account) => (
          <FacebookAccountCard
            key={account.provider_id}
            account={account}
            isSelected={selectedAccountId === account.provider_id}
            onSelect={() => onSelectAccount(account.provider_id)}
          />
        ))}
      </div>

      <div className={Styles.section}>
        <Text variant="secondary">
          Don't see your Facebook page listed? Make sure you've linked your ad account with Blaze. If you still don't
          see it, you may need to get access to the page.
        </Text>
        <Button variant="tertiary" size="sm" onPress={handleLinkAdAccount} endIcon={LinkExternal}>
          Link Page to Blaze
        </Button>
      </div>
    </div>
  )
}
